import {HTTP} from "@/helpers/http-common"
import * as R from "ramda";

const get = perfil =>new Promise((resolve,reject)=>{
  const {id} = perfil;
  HTTP.get(
    `/api/perfiles/${id}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const getPrivileges = perfil => new Promise((resolve,reject)=>{
  const {id} = perfil;
  HTTP.get(
    `/api/privilegiosPerfiles/${id}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const save = (perfil) =>new Promise((resolve,reject)=>{
  const {groupName , descripcion } = perfil;
  HTTP
  .post(
    '/api/perfiles'
    , {id:null
      , ["group_name"]:groupName
      , descripcion
      , estatus:"A"}
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const update = (perfil) =>new Promise((resolve,reject)=>{
  const {id, groupName , descripcion} = perfil;
  HTTP
  .put(
    '/api/perfiles'
    , {
      id
      , ["group_name"]:groupName
      , descripcion
      , estatus:"A"
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const disable = (perfil) =>new Promise((resolve,reject)=>{
  const {id} = perfil;
  HTTP
  .delete(
    "/api/perfiles/"
    , {
      params:{id}
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const addPrivilege = privilegio => new Promise((resolve,reject)=>{
  const {group_id , authority} = privilegio;
  let authorityVal = authority;
  if(authority.key != undefined)
  {
    authorityVal = authority.key;
  }
  HTTP
  .post(
    '/api/privilegiosPerfiles'
    , {
      group_id:{
        id:group_id
      }
      , authority:authorityVal
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const removePrivilege=privilegio =>new Promise((resolve,reject)=>{
  console.log(privilegio)
  const {group_id , authority } = privilegio;
  let authorityVal = authority;
  if(authority.key != undefined)
  {
    authorityVal = authority.key;
  }

  HTTP
  .delete(
    "/api/privilegiosPerfiles"
    , {
      params:{
        group_id
        , 'authority':authorityVal
      }
    }
  ).then((response)=>{
    resolve(response)
  })
  .catch((error)=>{
    reject(error)
  });
});
//Export methods
export default {
  get
  , save
  , update
  , disable
  , getPrivileges
  , addPrivilege
  , removePrivilege
}





// WEBPACK FOOTER //
// ./src/services/seguridad/perfil/index.js